// eslint-disable-next-line import/prefer-default-export
export { default as SUBURB_STATISTICS_FRAGMENT } from './suburb-statistics-fragment';
